const PRELOAD_ERROR_EVENT = 'vite:preloadError'
const RECOVERED_APP_VERSION_KEY = 'driver360:preload-recovery-version'

type RecoveryStorage = Pick<Storage, 'getItem' | 'setItem'>

interface PreloadErrorRecoveryOptions {
  target?: EventTarget
  getStorage?: () => RecoveryStorage
  getAppVersion?: () => string
  reload?: () => void
}

const getCurrentAppVersion = () =>
  document.querySelector<HTMLScriptElement>('script[type="module"][src]')
    ?.src ?? 'unknown'

export const registerPreloadErrorRecovery = (
  options: PreloadErrorRecoveryOptions = {},
) => {
  const {
    target = window,
    getStorage = () => window.sessionStorage,
    getAppVersion = getCurrentAppVersion,
    reload = () => window.location.reload(),
  } = options

  const handlePreloadError: EventListener = (event) => {
    try {
      const storage = getStorage()
      const appVersion = getAppVersion()

      console.log({
        storage,
        appVersion,
      })

      if (storage.getItem(RECOVERED_APP_VERSION_KEY) === appVersion) {
        return
      }

      storage.setItem(RECOVERED_APP_VERSION_KEY, appVersion)
    } catch {
      return
    }

    reload()
    event.preventDefault()
  }

  target.addEventListener(PRELOAD_ERROR_EVENT, handlePreloadError)

  return () =>
    target.removeEventListener(PRELOAD_ERROR_EVENT, handlePreloadError)
}
